
const sliderEl = document.querySelector('.glide--hpslider');
const skeleton = document.querySelector('.js-hpmenu-skeleton');     

if (sliderEl) {
    let sliderInterval;
    let sliderIntervalValue = 1;
    let sliderProgressWidth = 0;
    
    await new Promise(r => setTimeout(r, 300));
    let {default: Glide, Breakpoints, Controls, Swipe} = await import("@glidejs/glide/dist/glide.modular.esm");

    if (skeleton) {
        skeleton.style.display = 'none';
        sliderEl.style.display = 'block';
    }
    const slider = new Glide(sliderEl, {
        gap: 0,
        activeNav: 'active'
    }).mount({Controls, Breakpoints, Swipe});

    let play = function () {
        const bullets = sliderEl.querySelectorAll('.glide__bullet-progress');
        clearInterval(sliderInterval);
        sliderInterval = setInterval(function () {
            if (sliderIntervalValue >= 75) {
                slider.go('>');

                sliderIntervalValue = 1;
                clearInterval(sliderInterval);
                play();
            } else {
                sliderIntervalValue++;
                sliderProgressWidth = ((sliderIntervalValue * 100) / 70) / 100;

                bullets.forEach(function (bullet) {
                    bullet.style.transform = 'scaleX(' + sliderProgressWidth + ')';
                });
            }
        }, 70);
    }

    let pause = function () {
        clearInterval(sliderInterval);
    }

    play();

    sliderEl.addEventListener('mouseover', function () {
        pause();
    });

    sliderEl.addEventListener('mouseout', function () {
        play();
    });
} else {
    if (skeleton) {
        skeleton.style.display = 'none';
    }
}

const afterSliderEl = document.querySelector('.glide--afterhpslider');
const afterhpsliderSkeleton = document.querySelector('.js-afterhpslider-skeleton');

if (afterSliderEl) {
    await new Promise(r => setTimeout(r, 300));
    let {default: Glide, Autoplay, Swipe} = await import("@glidejs/glide/dist/glide.modular.esm");
    if (afterhpsliderSkeleton) {
        afterhpsliderSkeleton.style.display = 'none';
        afterSliderEl.style.display = 'block';
    }
    new Glide(afterSliderEl, {
        autoplay: 5000,
    }).mount({Autoplay, Swipe});
}
